import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import auth from './auth';
import members from './members';
import blogs from './blogs';
import global from './global';
import modal from './modal';
import course from './course';
import coupon from './coupon';
import product from './product';
import reservation from './reservation';
import old from './old';
import event from './event';

const reducers = combineReducers({
	routing: routerReducer,
	auth,
	members,
	blogs,
	global,
	modal,
	course,
	coupon,
	product,
	reservation,
	old,
	event,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js